export const DETAIL_TABS = {
    FINANCE: 'finance',
    PRODUCT: 'products',
    ITEM: 'items'
}